export const LMS_LEARNING_PATHS_RESET_STATE = 'LMS_LEARNING_PATHS_RESET_STATE';
export const LMS_LEARNING_PATHS_CURRENT_ITEM = 'LMS_LEARNING_PATHS_CURRENT_ITEM';

export const LMS_LEARNING_PATHS_REQUEST_LOADING = 'LMS_LEARNING_PATHS_REQUEST_LOADING';
export const LMS_LEARNING_PATHS_REQUEST_SUCCESS = 'LMS_LEARNING_PATHS_REQUEST_SUCCESS';
export const LMS_LEARNING_PATHS_REQUEST_FAILED = 'LMS_LEARNING_PATHS_REQUEST_FAILED';

export const LMS_LEARNING_PATHS_CURRENT_ACTION = 'LMS_LEARNING_PATHS_CURRENT_ACTION';
export const LMS_LEARNING_PATHS_RESET_ACTION = 'LMS_LEARNING_PATHS_RESET_ACTION';
